module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#listicle",
      toString: function () {
        return this.url;
      }
    }